// Travelsera blog & travel guide posts (original content)
export const blogPosts = [
  {
    slug: 'first-timers-guide-to-bali',
    title: "A First-Timer's Guide to Bali: Beaches, Rice Fields & Sunset Rituals",
    excerpt:
      "Everything a first-time visitor needs to plan a stress-free Bali trip \u2014 the best areas to stay, must-do experiences, and how many days to spend where.",
    author: 'Aditi Rao',
    category: 'International',
    tags: ['Bali', 'Indonesia', 'Beach', 'First-Timer'],
    date: '2026-06-14',
    readTime: '9 min read',
    hero: 'https://images.pexels.com/photos/1802183/pexels-photo-1802183.jpeg?auto=compress&cs=tinysrgb&w=1600',
    fbType: 'beach',
    sections: [
      {
        heading: 'Why Bali still charms after all these years',
        body:
          "Bali is one of those rare destinations that manages to feel both wildly popular and quietly personal. You can spend one day watching a sunrise from a volcano and the next lounging beside an infinity pool that looks out over jungle. For a first-timer, the trick is not trying to do everything \u2014 it is choosing two or three neighbourhoods, staying long enough to slow down, and letting the island fill in the rest.",
      },
      {
        heading: 'How many days do you actually need?',
        body:
          "Five nights is the minimum we recommend, seven is ideal. Any shorter and you will spend most of your trip in transit between areas. A comfortable split looks like this: 2 nights in the south (Seminyak or Canggu for beaches and cafes), 2 nights in Ubud (rice terraces, temples, wellness), and 2 nights on the coast or islands (Nusa Penida, Nusa Lembongan or Uluwatu for cliffs and snorkelling).",
      },
      {
        heading: 'The three areas that suit different travellers',
        body:
          "Seminyak and Canggu are for you if you want beach clubs, brunch spots and lively evenings. Ubud is greener, calmer and full of art \u2014 pick it if yoga, waterfalls and rice terraces are your idea of holiday. Uluwatu and the Bukit Peninsula are for cliffside stays, surf breaks and dramatic sunsets from clifftop temples.",
      },
      {
        heading: 'Experiences worth planning ahead',
        body:
          "Book your Mount Batur sunrise trek at least a week in advance. Snorkelling day trips to Nusa Penida sell out during Indian holiday weeks. Reserve dinner at a cliffside restaurant in Uluwatu for your last night \u2014 you will thank yourself. And if you want a traditional Balinese cooking class, morning slots go faster than afternoon ones.",
      },
      {
        heading: 'Money, SIM and getting around',
        body:
          "Grab and Gojek work in most areas but not everywhere \u2014 having a private driver for a day or two is the most efficient way to see multiple sights. Withdraw cash in city ATMs rather than tourist ones. A local SIM with 15\u201320 GB of data costs less than a coffee back home and makes navigation and translation painless.",
      },
      {
        heading: 'Final tip: pack for two Bali\u2019s',
        body:
          "Coastal Bali is hot and humid; inland Ubud can get cool at night. Bring one light layer, reef-safe sunscreen, and comfortable sandals. Skip the heavy shoes \u2014 you will spend more time barefoot than you expect.",
      },
    ],
  },
  {
    slug: 'sikkim-and-darjeeling-in-monsoon',
    title: "Sikkim & Darjeeling in Monsoon: Should You Actually Go?",
    excerpt:
      "Off-season doesn\u2019t mean off-limits. Here\u2019s an honest look at what monsoon travel to Gangtok, Pelling and Darjeeling really feels like \u2014 and how to plan around it.",
    author: 'Rahul Menon',
    category: 'India',
    tags: ['Sikkim', 'Darjeeling', 'Monsoon', 'Hills'],
    date: '2026-06-02',
    readTime: '7 min read',
    hero: 'https://images.pexels.com/photos/1287145/pexels-photo-1287145.jpeg?auto=compress&cs=tinysrgb&w=1600',
    fbType: 'mountain',
    sections: [
      {
        heading: 'The case for going in the rains',
        body:
          "Everyone tells you to visit the eastern Himalayas in October or April. But between June and August, the hills wear a completely different mood. Prices drop by 30\u201340%, hotels have space, and the entire valley smells of wet pine and cardamom. You will not always get clear mountain views, but you will get waterfalls the size of buildings and monasteries wrapped in mist that feel almost cinematic.",
      },
      {
        heading: 'What monsoon really looks like day-to-day',
        body:
          "It rarely rains all day \u2014 mornings often start clear, clouds roll in by afternoon, and evenings turn cool. The trade-off is that landslides can occasionally close a road for a few hours. If your itinerary has flexibility built in, this is manageable. If you are on a tight schedule with fixed return flights, monsoon may not be your friend.",
      },
      {
        heading: 'Which places to prioritise',
        body:
          "Gangtok stays reasonably accessible year round \u2014 the roads are wider and better maintained. Pelling is stunning in monsoon because you get uninterrupted views of Kanchenjunga\u2019s foothills swimming in cloud. Darjeeling toy train rides feel magical in light rain. Skip North Sikkim (Lachung, Lachen) during heavy rain months \u2014 the roads there are frequently disrupted.",
      },
      {
        heading: 'What to pack (this is the part most people get wrong)',
        body:
          "One waterproof windcheater, not a bulky raincoat. Quick-dry pants over jeans (jeans stay wet for hours). Trekking sandals or shoes with grip. A dry bag or ziploc for your phone and camera. Woollens are usually unnecessary except at higher altitudes like Yumthang or Tsomgo Lake.",
      },
      {
        heading: 'Food and small pleasures',
        body:
          "Momos taste ten times better with hot chilli sauce when it is raining outside. Try thukpa, gundruk soup and a local millet drink called tongba if you are in Gangtok. In Darjeeling, sit at a hillside cafe with the first flush tea and let the mist wash over the valley \u2014 no photo will do it justice.",
      },
    ],
  },
  {
    slug: 'how-many-days-in-vietnam',
    title: "How Many Days You Need for Vietnam (Without Rushing)",
    excerpt:
      "Vietnam is long, narrow, and full of contrast. Here\u2019s how to build a 7, 10 or 14-day trip depending on whether you want beaches, cities, or countryside.",
    author: 'Neha Kapoor',
    category: 'International',
    tags: ['Vietnam', 'Itinerary', 'Southeast Asia'],
    date: '2026-05-22',
    readTime: '8 min read',
    hero: 'https://images.pexels.com/photos/2166711/pexels-photo-2166711.jpeg?auto=compress&cs=tinysrgb&w=1600',
    fbType: 'beach',
    sections: [
      {
        heading: 'The Vietnam mistake most first-timers make',
        body:
          "The country is 1,650 kilometres end to end. Trying to fit Hanoi, Halong Bay, Hue, Da Nang, Hoi An, Ho Chi Minh City and the Mekong Delta into seven days is exhausting and expensive. Pick a region and go deeper instead of ticking off a map.",
      },
      {
        heading: '7 days: The classic north Vietnam loop',
        body:
          "Two nights in Hanoi to eat street food and wander the Old Quarter, one night on a Halong Bay cruise, two nights in Ninh Binh (think Halong Bay on land, with rice fields and limestone karsts), then back to Hanoi for one buffer night before flying out.",
      },
      {
        heading: '10 days: Add central Vietnam',
        body:
          "Do the 7-day north loop, then fly to Da Nang. Spend three nights split between Hoi An\u2019s lantern-lit old town and a beach hotel in Da Nang. Hoi An is walkable, magical after dark, and one of the best places on the planet for tailored clothing.",
      },
      {
        heading: '14 days: North to south',
        body:
          "After central Vietnam, fly to Ho Chi Minh City for two nights, take a day trip to the Cu Chi tunnels, and spend one night in the Mekong Delta on a homestay. Ho Chi Minh feels louder and more chaotic than Hanoi \u2014 it is the perfect finale before flying home.",
      },
      {
        heading: 'Practical bits nobody tells you',
        body:
          "Domestic flights are cheap and short (usually under two hours). Trains are romantic but slow \u2014 the Reunification Express takes 30+ hours end to end. Cash is king outside big cities. And do not rent a scooter unless you have ridden one before \u2014 traffic in Hanoi and Saigon rewards experience only.",
      },
    ],
  },
  {
    slug: 'best-months-for-ladakh',
    title: "The Best (and Worst) Months to Visit Ladakh",
    excerpt:
      "Ladakh has one of the shortest tourist windows in India. Here\u2019s a month-by-month breakdown to help you pick your dates \u2014 and know what to skip.",
    author: 'Vikram Bisht',
    category: 'India',
    tags: ['Ladakh', 'Leh', 'Adventure', 'Season'],
    date: '2026-05-10',
    readTime: '6 min read',
    hero: 'https://images.pexels.com/photos/2662116/pexels-photo-2662116.jpeg?auto=compress&cs=tinysrgb&w=1600',
    fbType: 'mountain',
    sections: [
      {
        heading: 'Ladakh is not year-round \u2014 accept that first',
        body:
          "Unlike Goa or Kerala, Ladakh has a real season. From November to April, most of the region is cut off by snow. Roads to Nubra, Pangong and Turtuk close. Even flights to Leh get delayed regularly. Locals leave for winter jobs. Any glossy blog telling you December is a good time to visit is either doing the Chadar trek (a specific frozen-river trek) or has never actually been.",
      },
      {
        heading: 'May: The window opens',
        body:
          "Roads reopen through May. Manali\u2013Leh and Srinagar\u2013Leh highways are usually driveable by end of the month. Days are pleasant, nights are cold. Crowds are thin and hotel rates are 25\u201330% cheaper than July.",
      },
      {
        heading: 'June to mid-September: Peak',
        body:
          "This is when everyone visits, and for good reason. All passes are open, monasteries hold festivals, and the sky stays blue for weeks. It is also when prices peak, permits fill up, and Leh feels like a small international town. Book fixed departures at least six weeks in advance.",
      },
      {
        heading: 'Late September to October: The secret window',
        body:
          "Fewer tourists, cool but not frigid, and the landscape turns golden. Some higher passes may start closing towards mid-October, so keep your itinerary flexible. If you are going for photography or quiet, this is the best time.",
      },
      {
        heading: 'Two altitude rules you must not break',
        body:
          "Give yourself at least 36 hours in Leh before going higher. Drink 3\u20134 litres of water daily. If you feel a persistent headache, do not push higher \u2014 come down. Diamox helps but is not a substitute for proper acclimatisation. Every year, avoidable altitude illnesses ruin trips for travellers who ignore this.",
      },
    ],
  },
  {
    slug: 'family-friendly-southeast-asia',
    title: "Southeast Asia With Kids: 5 Destinations That Actually Work",
    excerpt:
      "Planning a family holiday abroad but nervous about long flights and unfamiliar food? These five destinations balance easy logistics with genuine wow-factor.",
    author: 'Priya Iyengar',
    category: 'Family',
    tags: ['Family', 'Kids', 'Southeast Asia', 'Singapore'],
    date: '2026-04-28',
    readTime: '10 min read',
    hero: 'https://images.pexels.com/photos/1157393/pexels-photo-1157393.jpeg?auto=compress&cs=tinysrgb&w=1600',
    fbType: 'family',
    sections: [
      {
        heading: 'What makes a destination truly family-friendly?',
        body:
          "It is not just about kid-focused attractions. The real factors are: short flights (under 6 hours from most Indian metros), safe drinking water, familiar food options, good hospitals if something goes wrong, and public transport or private drivers that are stroller and car-seat friendly.",
      },
      {
        heading: '1. Singapore',
        body:
          "Nothing beats Singapore for a first international trip with kids. Everything works, English is universal, and Sentosa Island alone can fill three days with Universal Studios, S.E.A. Aquarium and Adventure Cove. Add Gardens by the Bay and a night safari, and you have a full week without ever getting bored.",
      },
      {
        heading: '2. Kuala Lumpur & Langkawi combo',
        body:
          "KL is easy on the wallet with a mix of city fun (Aquaria KLCC, Sunway Lagoon) and clean malls for meal breaks. Fly one hour to Langkawi and swap it for beach time, cable cars, and a mangrove kayak trip. Halal food is widely available which suits Indian families.",
      },
      {
        heading: '3. Phuket + Krabi',
        body:
          "Long-stay resorts here are built around kids \u2014 splash pools, kids clubs, quiet beaches. Do a day trip to Phi Phi or the Similans, otherwise let the resort do the heavy lifting. Prices drop sharply in June\u2013September (shoulder season) with sunny mornings and afternoon rain showers.",
      },
      {
        heading: '4. Bali (yes, really)',
        body:
          "Skip the party areas. Book an all-inclusive villa in Nusa Dua or a family resort in Sanur. Both have calm beaches without strong currents. Add two nights in Ubud for cultural experiences \u2014 monkey forest, water temples and a Balinese cooking class.",
      },
      {
        heading: '5. Bangkok + Pattaya',
        body:
          "Bangkok has SEA LIFE, KidZania, and one of Asia\u2019s largest weekend markets. Take the two-hour drive to Pattaya for beach time and Nong Nooch Garden. Choose hotels with connecting rooms rather than single big rooms \u2014 easier for naps and downtime.",
      },
      {
        heading: 'One last tip for stress-free family travel',
        body:
          "Do not try to fit more than one destination change per week. Kids need routine to enjoy a holiday. Two locations in ten days is plenty. Give them at least one lazy day between activity-heavy days.",
      },
    ],
  },
  {
    slug: 'kashmir-in-autumn',
    title: "Why Autumn Might Be Kashmir\u2019s Most Underrated Season",
    excerpt:
      "Everyone knows Kashmir in spring or winter. But October and November paint the valley in colours you will not find in any postcard.",
    author: 'Zoya Ahmed',
    category: 'India',
    tags: ['Kashmir', 'Autumn', 'Chinar', 'Photography'],
    date: '2026-04-11',
    readTime: '5 min read',
    hero: 'https://images.pexels.com/photos/1591373/pexels-photo-1591373.jpeg?auto=compress&cs=tinysrgb&w=1600',
    fbType: 'mountain',
    sections: [
      {
        heading: 'When the chinars turn',
        body:
          "For about four weeks between mid-October and mid-November, the chinar trees across the Kashmir Valley shift from green to fire-red and burnt orange. Nishat Bagh, Shalimar Bagh and the University campus in Srinagar transform into open-air galleries. It is one of the most photographed windows of the year, and yet visitor numbers stay lower than in summer.",
      },
      {
        heading: 'What to add to your itinerary',
        body:
          "A shikara ride on Dal Lake early morning \u2014 the mist over the water with red-leafed trees on the shore is unreal. A day trip to Pahalgam to walk along the Lidder river through pine and chinar forests. Gulmarg has usually not received heavy snow yet, so the meadows are still walkable and the gondola runs.",
      },
      {
        heading: 'Weather and packing notes',
        body:
          "Daytime highs are 15\u201319\u00b0C. Nights drop close to freezing by early November. A warm mid-layer, gloves and a good jacket handle it. Rain is uncommon compared to spring, and the light stays soft all day \u2014 photographers, this is your season.",
      },
      {
        heading: 'Food that matches the season',
        body:
          "Kashmiri wazwan feels made for cool weather. Try rogan josh, gushtaba and a warm kahwa in the evenings. Roadside stalls sell freshly roasted chestnuts and sweet corn \u2014 small joys that make autumn Kashmir memorable.",
      },
    ],
  },
];

export const blogCategories = ['All', 'India', 'International', 'Family'];
